module.exports = {
  background: '#0b0b0c',
  backgroundDark: '#141416',

  text: '#eeeeee',

  primary: '#eeeeee',
  primaryLight: '#9a9a9f',
  primaryDark: '#0b0b0c',

  secondary: '#00ffff',
  secondaryLight: '#0b0b0c',
  secondaryDark: "#eeeeee"//'#ff0000',
};
